<template>
  <div class="app-main-content warehouse-home">
    <div class="grid-view">
      <div class="main-content" style="width: 90%">
        <span style="color: red;font-size: 18px">{{ $t('SeaExport.QueryThreeMonths') }}</span>
        <search-item
          config-module="130301"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @click-more="value=>filter.isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        />
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery()"
          />
        </div>
      </div>
      <el-tabs
        v-model="statusCode"
        tab-position="left"
        type="card"
        class="tabsPosition"
        style="height: 116px;min-width: 90px;max-width: 90px"
        @tab-click="toQuery()"
      >
        <el-tab-pane :label="trStatus[0].chineseName + '(' + allCount + ')'" :name="String(trStatus[0].code)" />
        <el-tab-pane :label="trStatus[1].chineseName + '(' + errorCount + ')'" :name="String(trStatus[1].code)" />
        <el-tab-pane :label="trStatus[3].chineseName + '(' + normalCount + ')'" :name="String(trStatus[3].code)" />
        <el-tab-pane :label="trStatus[2].chineseName + '(' + doneCount + ')'" :name="String(trStatus[2].code)" />
      </el-tabs>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ContainerNoHelper from '@/utils/containerNoHelper'
import DateUtils from '@/utils/dateUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import StrUtils from '@/utils/StrUtils'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as containerUsageApi from '@/api/seaExport/containerUsage'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import sign_ash from '@/assets/sign_ash.png' // 未到达
import sign_blue from '@/assets/sign_blue.png' // 已到达
import sign_red from '@/assets/sign_red.png' // 已超时
import wharf_ash from '@/assets/wharf_ash.png' // 未到达 码头
import wharf_blue from '@/assets/wharf_blue.png' // 已到达 码头
import wharf_red from '@/assets/wharf_red.png' // 已超时 码头
import car from '@/assets/car.png' // 车辆
import { getLoading } from '@/utils/utilBaseElement'
import { DocumentManage } from '@/utils/commonUtil'
import { TosNodeMessageUtils } from '@/views/cargo/v0/SeaExport/TrajectoryQuery/TosNodeMessageUtils'

export default {
  name: 'TrajectoryQuery',
  components: { searchItem, cargoLeftRightResize },
  data() {
    return {
      documentManage: new DocumentManage(),
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        onCellFocused: event => {
          this.selectedRowIndex = event.rowIndex
        }
      },
      columnDefs: [
        { headerName: this.$t('SeaExport.BlNo'), field: 'mbl', width: 120 },
        { headerName: this.$t('SeaExport.ContainerNo'), field: 'containerNo', width: 120,
          cellRenderer: this.containerUsageFiledLabelFunction
        },
        { headerName: this.$t('SeaExport.BusinessReferenceNo'), field: '', width: 120,
          cellRenderer: this.customerRefNoFunction
        },
        { headerName: this.$t('SeaExport.operationTrajectory'), field: '', width: 600,
          children: [
            { headerName: this.$t('SeaExport.pickupEmptyContainer'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, ''),
              tooltipValueGetter: params => params.data.toolTip
            },
            { headerName: this.$t('SeaExport.arrivalFactory'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, '1'),
              tooltipValueGetter: params => params.data.toolTip1
            },
            { headerName: this.$t('SeaExport.departureFactory'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, '2'),
              tooltipValueGetter: params => params.data.toolTip2
            },
            { headerName: this.$t('SeaExport.enterTerminal'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, '3', 'wharf'),
              tooltipValueGetter: params => params.data.toolTip3
            },
            { headerName: this.$t('SeaExport.customsRelease'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, '4'),
              tooltipValueGetter: params => params.data.toolTip4
            },
            { headerName: this.$t('SeaExport.terminalRelease'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, '5'),
              tooltipValueGetter: params => params.data.toolTip5
            },
            { headerName: this.$t('SeaExport.loadedOnVessel'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, '6'),
              tooltipValueGetter: params => params.data.toolTip6
            },
            { headerName: this.$t('SeaExport.departurePort'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, '11'),
              tooltipValueGetter: params => params.data.toolTip11
            },
            { headerName: this.$t('SeaExport.arrivalPort'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, '7'),
              tooltipValueGetter: params => params.data.toolTip7
            },
            { headerName: this.$t('SeaExport.destinationCustomsClearance'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, '8'),
              tooltipValueGetter: params => params.data.toolTip8
            },
            { headerName: this.$t('SeaExport.deliveryGoods'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, '9'),
              tooltipValueGetter: params => params.data.toolTip9
            },
            { headerName: this.$t('SeaExport.returnContainer'), field: '', width: 50,
              cellRenderer: params => this.cellRendererIconHandler(params, '10'),
              tooltipValueGetter: params => params.data.toolTip10
            }
          ]
        },
        { headerName: this.$t('SeaExport.driver'), field: 'tosDriverName', width: 100 },
        { headerName: this.$t('SeaExport.contactInfo'), field: 'tosDriverPhone', width: 100 },
        { headerName: this.$t('SeaExport.licensePlate'), field: 'tosCarNum', width: 100 },
        { headerName: this.$t('SeaExport.jobNumber'), field: 'tosLocation', width: 100,
          cellRenderer: this.jobNoFunction
        },
        { headerName: this.$t('SeaExport.vesselVoyage'), field: 'tosLocation', width: 120,
          cellRenderer: this.vesselFunction
        },
        { headerName: this.$t('SeaExport.customsDeclarationNo'), field: 'tosLocation', width: 120,
          cellRenderer: this.soNoFunction
        },
        { headerName: this.$t('SeaExport.sailingDate'), field: 'tosLocation', width: 120,
          cellRenderer: this.etdFunction
        },
        { headerName: this.$t('SeaExport.closingTime'), field: 'tosLocation', width: 120,
          cellRenderer: this.timeFunction
        },
        { headerName: this.$t('SeaExport.pickupEmptyContainer'), field: 'tosGstartTime', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: this.$t('SeaExport.arrivalFactory'), field: 'tosGinTime', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: this.$t('SeaExport.departureFactory'), field: 'tosGoutTime', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: this.$t('SeaExport.enterTerminal'), field: 'tosApproachTime', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: this.$t('SeaExport.customsRelease'), field: 'tosCustomReleaseDate', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: this.$t('SeaExport.terminalRelease'), field: 'tosWharfReleaseDate', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: this.$t('SeaExport.loadedOnVessel'), field: 'tosPlayDate', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: this.$t('SeaExport.departurePort'), field: 'tosActualUnBerthPlanDate', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: this.$t('SeaExport.arrivalPort'), field: 'tosActualArrivalTime', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: this.$t('SeaExport.destinationCustomsClearance'), field: 'tosDestPortCustomsClearanceTime', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: this.$t('SeaExport.deliveryGoods'), field: 'tosDestPortDeliveryTime', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: this.$t('SeaExport.returnContainer'), field: 'tosDestPortReturnTime', width: 120,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        { headerName: ' ', field: '', width: 50 }
      ],
      rowData: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 30
      },
      trStatus: Array.from(SeaExportConstants.TR_STATUS),
      statusCode: '1',
      conditions: {}, // 查询条件
      allCount: '0',
      errorCount: '0',
      normalCount: '0',
      doneCount: '0',
      message: new TosNodeMessageUtils()
    }
  },
  computed: {},
  created() {
    this.updateCountData()
  },
  mounted() {
    const context = this
    this.documentManage.set('errorImage', function(uid, type) {
      context.errorImage(uid, type)
    })
  },
  methods: {
    // 简单查询
    toSimpleQuery(data) {
      const condition = new AdvancedSearchOption(null, 'businessNo', data, OperatorConstants.OPERATOR_EQUAL.code)
      this.toAdvancedQuery([condition])
    },
    // 高级查询
    toAdvancedQuery(conditions) {
      const filter = {}
      for (const so of conditions) {
        if (so.fieldName === 'businessNo') {
          filter['businessNo'] = so
        } else if (so.fieldName === 'BlNo') {
          filter['BlNo'] = so
        } else if (so.fieldName === 'CStatus') {
          filter['CStatus'] = so
        } else if (so.fieldName === 'Time') {
          const arr = so.value.split(',')
          const time = new Map()
          for (const el of arr) {
            const arr1 = el.split('=')
            time.set(arr1[0], arr1[1])
          }
          filter['Time'] = time
        }
      }
      this.conditions = filter
      this.toQuery()
    },
    // 查询
    toQuery() {
      const filter = this.conditions
      // 客户状态
      filter.statusCode = this.statusCode
      filter.pageSize = this.filter.pageSize > 0 ? this.filter.pageSize : 30
      filter.pageNum = this.filter.pageNum > 0 ? this.filter.pageNum : 1
      const loading = getLoading()
      containerUsageApi.queryContainerTrajectoryList(filter).then(resp => {
        this.querySuccessHandler(resp)
      }).finally(() => loading.close())
    },
    querySuccessHandler(resp) {
      const data = resp.data
      if (data) {
        this.filter.total = Number(data.total)
        this.filter.pageNum = data.pageNum
        const list = data.list
        for (const containerUsage of list) {
          const container = containerUsage.container
          let truckingInfoNow = null
          const job = containerUsage.job
          const trucking = job.trucking
          if (trucking != null && trucking.length > 0) {
            truckingInfoNow = trucking[0]
          }
          containerUsage.mbl = job.mbl
          const approachTime = (container.approachDate == null) ? containerUsage.tosGarriveTime : container.approachDate
          const seaJob = containerUsage.job
          this.checkNumber(containerUsage, containerUsage.tosGstartTime, containerUsage.tosGinTime, containerUsage.tosGoutTime, approachTime,
            container.customReleaseDate, container.wharfReleaseDate, container.playDate,
            seaJob.actualArrivalTime, seaJob.destPortCustomsClearanceTime, seaJob.destPortDeliveryTime,
            seaJob.destPortReturnTime, seaJob.actualUnBerthPlanDate)
          this.dataImage(containerUsage, approachTime, container, seaJob, truckingInfoNow)
        }
        this.rowData = list
      }
    },
    checkNumber(containerUsage, tosGstartTime, tosGinTime, tosGoutTime, approachDate,
      customReleaseDate, wharfReleaseDate, playDate,
      actualArrivalTime, destPortCustomsClearanceTime, destPortDeliveryTime,
      destPortReturnTime, actualUnBerthPlanDate) {
      if (!StrUtils.isEmpty(destPortReturnTime)) {
        containerUsage.carImage10 = true
      } else if (!StrUtils.isEmpty(destPortDeliveryTime)) {
        containerUsage.carImage9 = true
      } else if (!StrUtils.isEmpty(destPortCustomsClearanceTime)) {
        containerUsage.carImage8 = true
      } else if (!StrUtils.isEmpty(actualArrivalTime)) {
        containerUsage.carImage7 = true
      } else if (!StrUtils.isEmpty(actualUnBerthPlanDate)) {
        containerUsage.carImage11 = true
      } else if (!StrUtils.isEmpty(playDate)) {
        containerUsage.carImage6 = true
      } else if (!StrUtils.isEmpty(wharfReleaseDate)) {
        containerUsage.carImage5 = true
      } else if (!StrUtils.isEmpty(customReleaseDate)) {
        containerUsage.carImage4 = true
      } else if (!StrUtils.isEmpty(approachDate)) {
        containerUsage.carImage3 = true
      } else if (!StrUtils.isEmpty(tosGoutTime)) {
        containerUsage.carImage2 = true
      } else if (!StrUtils.isEmpty(tosGinTime)) {
        containerUsage.carImage1 = true
      } else if (!StrUtils.isEmpty(tosGstartTime)) {
        // 默认起始站 放小车
        containerUsage.carImage = true
      }
    },
    dataImage(containerUsage, approachTime, container,
      seaJob, truckingInfoNow) {
      containerUsage.wharf3 = wharf_ash
      containerUsage.sign = containerUsage.sign1 = containerUsage.sign2 = containerUsage.sign4 = containerUsage.sign5 = sign_ash
      containerUsage.sign6 = containerUsage.sign7 = containerUsage.sign8 = containerUsage.sign9 = containerUsage.sign10 = containerUsage.sign11 = sign_ash
      containerUsage.toolTip = containerUsage.toolTip1 = containerUsage.toolTip2 = containerUsage.toolTip3 = containerUsage.toolTip4 = containerUsage.toolTip5 = ''
      containerUsage.toolTip6 = containerUsage.toolTip7 = containerUsage.toolTip8 = containerUsage.toolTip9 = containerUsage.toolTip10 = containerUsage.toolTip11 = ''
      if (!StrUtils.isEmpty(containerUsage.tosGstartTime)) {
        containerUsage.sign = sign_blue
        containerUsage.toolTip = ColumnUtils.dateTimeLabelFunc(containerUsage.tosGstartTime)
      }
      // 实际到达工厂时间存在 到厂节点
      if (!StrUtils.isEmpty(containerUsage.tosGinTime)) {
        containerUsage.sign1 = sign_blue
        containerUsage.toolTip1 = ColumnUtils.dateTimeLabelFunc(containerUsage.tosGinTime)
      }
      // 实际离开工厂时间 存在
      if (!StrUtils.isEmpty(containerUsage.tosGoutTime)) {
        containerUsage.sign2 = sign_blue
        containerUsage.toolTip2 = ColumnUtils.dateTimeLabelFunc(containerUsage.tosGoutTime)
      }
      // 实际到达时间 存在
      if (!StrUtils.isEmpty(approachTime)) {
        containerUsage.tosApproachTime = approachTime
        containerUsage.wharf3 = wharf_blue
        containerUsage.toolTip3 = ColumnUtils.dateTimeLabelFunc(approachTime)
      }
      // 海关放行时间 存在
      if (!StrUtils.isEmpty(container.customReleaseDate)) {
        containerUsage.tosCustomReleaseDate = container.customReleaseDate
        containerUsage.sign4 = sign_blue
        containerUsage.toolTip4 = ColumnUtils.dateTimeLabelFunc(container.customReleaseDate)
      }
      // 码头放行时间 存在
      if (!StrUtils.isEmpty(container.wharfReleaseDate)) {
        containerUsage.tosWharfReleaseDate = container.wharfReleaseDate
        containerUsage.sign5 = sign_blue
        containerUsage.toolTip5 = ColumnUtils.dateTimeLabelFunc(container.wharfReleaseDate)
      }
      // 开航时间 存在
      if (!StrUtils.isEmpty(container.playDate)) {
        containerUsage.tosPlayDate = container.playDate
        containerUsage.sign6 = sign_blue
        containerUsage.toolTip6 = ColumnUtils.dateTimeLabelFunc(container.playDate)
      }
      // 实际到港时间 存在
      if (!StrUtils.isEmpty(seaJob.actualArrivalTime)) {
        containerUsage.tosActualArrivalTime = seaJob.actualArrivalTime
        containerUsage.sign7 = sign_blue
        containerUsage.toolTip7 = ColumnUtils.dateTimeLabelFunc(seaJob.actualArrivalTime)
      }
      // 目的港放关时间 存在
      if (!StrUtils.isEmpty(seaJob.destPortCustomsClearanceTime)) {
        containerUsage.tosDestPortCustomsClearanceTime = seaJob.destPortCustomsClearanceTime
        containerUsage.sign8 = sign_blue
        containerUsage.toolTip8 = ColumnUtils.dateTimeLabelFunc(seaJob.destPortCustomsClearanceTime)
      }
      // 目的港送货时间 存在
      if (!StrUtils.isEmpty(seaJob.destPortDeliveryTime)) {
        containerUsage.tosDestPortDeliveryTime = seaJob.destPortDeliveryTime
        containerUsage.sign9 = sign_blue
        containerUsage.toolTip9 = ColumnUtils.dateTimeLabelFunc(seaJob.destPortDeliveryTime)
      }
      // 目的港还箱时间 存在
      if (!StrUtils.isEmpty(seaJob.destPortReturnTime)) {
        containerUsage.tosDestPortReturnTime = seaJob.destPortReturnTime
        containerUsage.sign10 = sign_blue
        containerUsage.toolTip10 = ColumnUtils.dateTimeLabelFunc(seaJob.destPortReturnTime)
      }
      // 离港
      if (!StrUtils.isEmpty(seaJob.actualUnBerthPlanDate)) {
        containerUsage.tosActualUnBerthPlanDate = seaJob.actualUnBerthPlanDate
        containerUsage.sign11 = sign_blue
        containerUsage.toolTip11 = ColumnUtils.dateTimeLabelFunc(seaJob.actualUnBerthPlanDate)
      }
      let object = {}
      if (containerUsage.tosErrorType !== '' && containerUsage.tosErrorType != null) {
        object = JSON.decode(containerUsage.tosErrorType)
      }
      // 出发提箱
      if (object.hasOwnProperty('start')) {
        let gTime = null
        if (truckingInfoNow != null) {
          gTime = new Date(truckingInfoNow.loadingDate)
          gTime.setHours(gTime.getHours() - truckingInfoNow.travelHour)
          gTime.setMinutes(gTime.getMinutes() - truckingInfoNow.travelMinute)
        }
        containerUsage.sign = sign_red
        containerUsage.toolTip = this.message.getMessageByType('startMessage', gTime, containerUsage.tosGstartTime)
      }
      // 到厂
      if (object.hasOwnProperty('toTheFactory')) {
        let dTime = null
        if (truckingInfoNow != null) {
          dTime = truckingInfoNow.loadingDate
        }
        containerUsage.sign1 = sign_red
        containerUsage.toolTip1 = this.message.getMessageByType('toTheFactoryMessage', dTime, containerUsage.tosGinTime)
      }
      // 离厂
      if (object.hasOwnProperty('offFactory')) {
        var lTime = null
        if (truckingInfoNow != null) {
          lTime = new Date(seaJob.terminalCutoff)
          lTime.setHours(lTime.getHours() - truckingInfoNow.travelHour - 2)
          lTime.setMinutes(lTime.getMinutes() - truckingInfoNow.travelMinute)
        }
        containerUsage.sign2 = sign_red
        containerUsage.toolTip2 = this.message.getMessageByType('offFactoryMessage', lTime, containerUsage.tosGoutTime)
      }
      // 海关放行
      if (object.hasOwnProperty('customsRelease')) {
        containerUsage.sign4 = sign_red
        containerUsage.toolTip4 = this.message.getMessageByType('customsReleaseMessage', seaJob.customCutoff, container.customReleaseDate)
      }
      // 码头放行
      if (object.hasOwnProperty('wharfRelease')) {
        containerUsage.sign5 = sign_red
        containerUsage.toolTip5 = this.wharfReleaseLabFunction(seaJob.berthPlanDate, container.wharfReleaseDate, containerUsage)
      }
      // 上船
      if (object.hasOwnProperty('aboard')) {
        containerUsage.sign6 = sign_red
        containerUsage.toolTip6 = this.message.getMessageByType('aboardMessage', seaJob.actualUnBerthPlanDate, container.playDate)
      }
      // 离港
      if (object.hasOwnProperty('departureFrom')) {
        containerUsage.sign11 = sign_red
        containerUsage.toolTip11 = this.message.getMessageByType('departureFromMessage', seaJob.unBerthPlanDate, seaJob.actualUnBerthPlanDate)
      }
      // 到港
      if (object.hasOwnProperty('arrivalPort')) {
        containerUsage.sign7 = sign_red
        containerUsage.toolTip7 = this.message.getMessageByType('arrivalPortMessage', seaJob.ETA, seaJob.actualArrivalTime)
      }
      // 还箱
      if (object.hasOwnProperty('returnBox')) {
        var hTime = null
        if (!StrUtils.isEmpty(seaJob.actualArrivalTime)) {
          hTime = new Date(seaJob.actualArrivalTime)
        }
        hTime.setDate(hTime.getDay() + 7)
        containerUsage.sign10 = sign_red
        containerUsage.toolTip10 = this.message.getMessageByType('returnBoxMessage', hTime, seaJob.destPortReturnTime)
      }
      return containerUsage
    },
    containerUsageFiledLabelFunction(params) {
      const usage = params.data
      if (usage.container) {
        const value = usage.container.containerNo
        if (usage && !ContainerNoHelper.checkContainerNo(usage.container.containerNo)) {
          return `<span style="color: #FF0000">${value}</span>`
        }
        return value
      }
      return ''
    },
    customerRefNoFunction(params) {
      const seaJob = params.data.job
      return this.defaultString(seaJob.customerRefNo)
    },
    defaultString(text) {
      if (text == null || text === '') {
        return '-'
      }
      return text
    },
    jobNoFunction(params) {
      const j = params.data.job
      return j.jobNo
    },
    vesselFunction(params) {
      const j = params.data.job
      return this.defaultString(j.vessel) + '-' + this.defaultString(j.voyageFlight)
    },
    soNoFunction(params) {
      const sea = params.data.job
      return this.defaultString(sea.soNo)
    },
    etdFunction(params) {
      const j = params.data.job
      const time = DateUtils.formatStandardDate(j.etd)
      return this.defaultString(time)
    },
    timeFunction(params) {
      const seaJob = params.data.job
      const customCutoff = DateUtils.formatStandardDate(seaJob.customCutoff)
      return this.defaultString(customCutoff)
    },
    updateCountData() {
      containerUsageApi.queryContainerTrajectoryNum().then(resp => {
        if (resp.data) {
          this.allCount = resp.data['allNum']
          this.errorCount = resp.data['errorNum']
          this.normalCount = resp.data['normalNum']
          this.doneCount = resp.data['doneNum']
        }
      })
    },
    cellRendererIconHandler(params, type, source) {
      let sign
      if (source) {
        sign = params.data[source + type]
      } else {
        sign = params.data['sign' + type]
      }
      const errorImage = this.documentManage.getPath('errorImage')
      let value = `<img src="${sign}" onclick="${errorImage}('${params.data.uuid}','${type}')" alt="${sign}" height="16px" width="16px"/>`
      if (params.data['carImage' + type]) {
        value += `<img src="${car}" alt="${car}" />`
      }
      return value
    },
    errorImage(uuid, type) {
      const data = this.rowData.find(row => row.uuid === uuid)
      const text = data['toolTip' + type]
      let t = ''
      let red = false
      if (data['sign' + type] === sign_red) {
        red = true
      }
      if (!red) {
        return
      }
      this.$confirm(text + ',异常是否处理完成？', this.$t('common.tips.prompt'), {
        confirmButtonText: '已处理',
        cancelButtonText: '暂不处理',
        type: 'info',
        closeOnClickModal: false
      }).then(() => {
        let eventMessage = ''
        switch (type) {
          case '':
            t = 'start'
            eventMessage = 'start_event'
            break
          case '1':
            t = 'toTheFactory'
            eventMessage = 'to_the_factory_event'
            break
          case '2':
            t = 'offFactory'
            eventMessage = 'off_factory_event'
            break
          case '3':
            break
          case '4':
            t = 'customsRelease'
            eventMessage = 'customs_release_event'
            break
          case '5':
            t = 'wharfRelease'
            eventMessage = 'wharf_release_event'
            break
          case '6':
            t = 'aboard'
            eventMessage = 'aboard_event'
            break
          case '7':
            t = 'arrivalPort'
            eventMessage = 'arrival_port_event'
            break
          case '8':
            break
          case '9':
            break
          case '10':
            t = 'returnBox'
            eventMessage = 'return_box_event'
            break
          case '11':
            t = 'departureFrom'
            eventMessage = 'departure_from_event'
            break
        }
        if (data.tosErrorType !== '' && data.tosErrorType != null) {
          const object = JSON.decode(data.tosErrorType)
          object[t] = 'Handle'
          data.tosErrorType = JSON.encode(object)
          const params = {}
          params.uuid = data.key
          params.eventMessage = eventMessage
          params.tosErrorType = data.tosErrorType
          containerUsageApi.updateContainerErrorNode(params).then(resp => {
            if (resp.data === 1) {
              this.$message.success('处理成功')
            } else {
              this.$message.error('处理异常，请刷新后重试！')
            }
          })
        }
        this.updateContainerData(data)
      })
    },
    updateContainerData(containerUsage) {
      const container = containerUsage.container
      const seaJob = containerUsage.job
      const approachTime = (container.approachDate == null) ? containerUsage.tosGarriveTime : container.approachDate
      const job = containerUsage.job
      const trucking = job.trucking
      let truckingInfoNow = null
      if (trucking != null && trucking.length > 0) {
        truckingInfoNow = trucking[0]
      }
      this.dataImage(containerUsage, approachTime, container, seaJob, truckingInfoNow)
    },
    // 码头放行
    wharfReleaseLabFunction(berthPlanDate, wharfReleaseDate, containerUsage) {
      let mTime = new Date()
      if (berthPlanDate != null) {
        mTime = new Date(berthPlanDate.valueOf())
      }
      mTime.setHours(mTime.getHours() - 12)
      return this.message.getMessageByType('wharfReleaseMessage', mTime, wharfReleaseDate)
    }
  }
}
</script>

<style scoped>
  /*绝对定位到左上角*/
  .tabsPosition {
    position: absolute;
    left: 10px;
    top: 10px
  }
  /*相对父容器右移100像素*/
  .main-content {
    position: relative;
    left: 100px;
  }
</style>
